module.exports = __webpack_public_path__ + "static/media/typing.0e3ccaf1.gif";